import { ErrorResponse } from '@cash-web/data-access-cash-app-pay-api-types'

import { isObject } from '../../utils/guards'

const isErrorResponse = (data: unknown) => isObject(data) && 'category' in data && 'code' in data

export const isApiError = (data: unknown): data is { errors: ErrorResponse[] } =>
  isObject(data) && 'errors' in data && Array.isArray(data.errors) && data.errors.every(isErrorResponse)
